import React from 'react';
import './PieChart.css';

function PieChart({ usedMB, maxMB = 100 }) {
  const percentage = Math.min((usedMB / maxMB) * 100, 100);
  const freeMB = Math.max(maxMB - usedMB, 0);
  const freePercentage = Math.max(100 - percentage, 0);

  // Calculate pie chart segments
  const radius = 80;
  const circumference = 2 * Math.PI * radius;
  
  // Used space segment (starts at top, goes clockwise)
  const usedDashArray = `${(percentage / 100) * circumference} ${circumference}`;
  
  // Color based on usage
  let usedColor = '#4CAF50'; // Green
  if (percentage > 80) {
    usedColor = '#f44336'; // Red
  } else if (percentage > 60) {
    usedColor = '#ff9800'; // Orange
  }

  return (
    <div className="pie-chart-container">
      <svg width="200" height="200" viewBox="0 0 200 200">
        {/* Background circle (free space) */}
        <circle
          cx="100"
          cy="100"
          r={radius}
          fill="none"
          stroke="#e0e0e0"
          strokeWidth="40"
        />
        
        {/* Used space arc */}
        <circle
          cx="100"
          cy="100"
          r={radius}
          fill="none"
          stroke={usedColor}
          strokeWidth="40"
          strokeDasharray={usedDashArray}
          strokeDashoffset={circumference / 4}
          transform="rotate(-90 100 100)"
          className="pie-segment"
        />
        
        {/* Center text */}
        <text
          x="100"
          y="95"
          textAnchor="middle"
          fontSize="24"
          fontWeight="bold"
          fill="#333"
        >
          {usedMB.toFixed(1)} MB
        </text>
        <text
          x="100"
          y="115"
          textAnchor="middle"
          fontSize="14"
          fill="#666"
        >
          of {maxMB} MB
        </text>
      </svg>
      
      <div className="pie-legend">
        <div className="legend-item">
          <span className="legend-color" style={{ backgroundColor: usedColor }}></span>
          <span className="legend-label">Used: {usedMB.toFixed(2)} MB ({percentage.toFixed(1)}%)</span>
        </div>
        <div className="legend-item">
          <span className="legend-color" style={{ backgroundColor: '#e0e0e0' }}></span>
          <span className="legend-label">Free: {freeMB.toFixed(2)} MB ({freePercentage.toFixed(1)}%)</span>
        </div>
      </div>
    </div>
  );
}

export default PieChart;

